import { useQuery } from '@tanstack/react-query'
import dayjs from 'dayjs'
import ReactMarkdown from 'react-markdown'

import { EXTERNAL_URLS } from '@/lib/constants/url'
import { getTermsOfServiceQuery } from '@/lib/sanity'

export const TermsOfServicePage = () => {
  const { data } = useQuery(getTermsOfServiceQuery)

  return (
    <>
      <div className="mb-5 flex h-[70px] items-center">
        <div className="pl-[30px]">
          <img src={EXTERNAL_URLS.lawfullyProFullLogo} alt="Lawfully Pro Logo" />
        </div>
      </div>
      <article className="mx-auto max-w-[960px] px-5 pb-20">
        <h2 className="mb-6 scroll-m-20 border-b pb-2 text-3xl font-semibold tracking-tight first:mt-0">
          Terms of Service For Lawfully Pro
        </h2>
        {!!data?.content && (
          <>
            <div className="mb-6 text-gray-500">Last updated: {dayjs(data?.lastUpdateDate).format('MMMM D, YYYY')}</div>
            <ReactMarkdown
              components={{
                h1: (props) => <h1 className="mb-5 mt-9 text-3xl font-bold" {...props} />,
                h2: (props) => <h2 className="mb-4 mt-7 text-2xl font-semibold" {...props} />,
                h3: (props) => <h3 className="mb-3 mt-6 text-xl font-medium" {...props} />,
                p: (props) => <p className="mb-5 leading-relaxed" {...props} />,
                a: (props) => <a className="underline hover:text-primary" {...props} />,
                ul: (props) => <ul className="mb-5 list-inside list-disc" {...props} />,
                ol: (props) => <ol className="mb-5 list-inside list-decimal" {...props} />,
                li: (props) => <li className="mb-2 ml-4" {...props} />,
              }}
            >
              {data?.content}
            </ReactMarkdown>
          </>
        )}
      </article>
    </>
  )
}
